import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    CLEAR_SELECTED_PRODUCTS,  ADD_SELECTED_USERS,REMOVE_SELECTED_USERS  }  from "actions/actionTypes";
import config from  '../../../config';
import {Link} from 'react-router';
import {customTableSelect,actionsFormatter} from 'util/Utils';
class AdminUserListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage
        };
    }

    onRowSelect(row, isSelected, e) {
         var actionName =   isSelected ? ADD_SELECTED_USERS : REMOVE_SELECTED_USERS;
         this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        var actionName =   isSelected ? ADD_SELECTED_USERS : REMOVE_SELECTED_USERS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
       return customTableSelect(props, {table:this.refs.table, selectedRows:this.props.adminUsers.selectedUsers});
    }
    customActionsFormatter(cell, row, extra){

        var menuItemsMap  =    [ ]
        if (config.checkAccessRights.call(this,{ resources:['users_edit']}) ){
                  menuItemsMap.push({onClick: 'editUser', label: 'Edit User'})
                if (!_.get(row, 'SellerRecord._id')) {
                    menuItemsMap.push({
                        onClick: function (row) {
                            this.context.router.push(`/admin/seller/${encodeURIComponent(row._id)}/add`)
                        }, label: 'Add Seller'
                    })
                }
             if (_.get(row, 'CustomData.SellerGroupID') &&   config.checkAccessRights.call(this,{ resources:['partner_dashboard']}) ){

                menuItemsMap.push({
                    onClick: function (row) {
                        this.props.dispatchAction({}, CLEAR_SELECTED_PRODUCTS)
                        window.open((config.getEnvironmentName() == 'production' ? config.getEnvironment().directServerBaseURL:config.getEnvironment().clientSideURL)+'/partner/products?SellerGroupID='+_.get(row, 'CustomData.SellerGroupID'), "_blank")
                      //  this.context.router.push('/partner/products?SellerGroupID='+_.get(row, 'CustomData.SellerGroupID'))
                    }, label: 'Go to partner dashboard'
                })
            }
            }
        return  actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editUser(row) {
        window.open(config.getEnvironment().clientSideURL+`/admin/user/${encodeURIComponent(row._id)}/edit`, "_blank")

     }
    render() {
        console.log('partner_dashboard',  config.checkAccessRights.call(this,{ resources:['partner_dashboard']})  );
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)
        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.adminUsers.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn  width="100px"  dataField='firstName'     dataSort={true}>FirstName</TableHeaderColumn>
                        <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn  width="100px"  dataField='lastName'      dataSort={true}>LastName</TableHeaderColumn>
                        <TableHeaderColumn  width="150px"   dataField='email'   dataSort={true}>Email</TableHeaderColumn>
                        <TableHeaderColumn   dataAlign="center"       columnClassName={'actions-column'}
                                            dataFormat={ this.customActionsFormatter.bind(this) } ></TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>

        );
    }
}


export default AdminUserListTable;
